import { instance } from '@/services/klarbuss-api'
import { AxiosResponse } from 'axios'

export function checkIn(arrivalUuid: string): Promise<AxiosResponse<unknown>> {
  return instance.post(`/arrival/${arrivalUuid}/check-in`)
}
